import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { daiWebhooks } from '../../docs-routes'
import type { CSSProperties } from 'react'

const popupBodyStyle: CSSProperties = {
  marginBottom: '16px',
  marginTop: '5px'
}

const WebhookUrlDescription = () =>
  <>
    <Header
      hasNoTopMargin
      rank={4}
    >
      URL
    </Header>
    <div style={popupBodyStyle}>
      <Paragraph>
        <Color variant='greyB'>
          Enter the URL for the application with which you want to send notifications.
        </Color>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToDocusaurus path={daiWebhooks}>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </Paragraph>
  </>

export default WebhookUrlDescription
